// icon:information-circle-outline | Ionicons https://ionicons.com/ | Ionic Framework
import * as React from "react";

function IconInformationCircleOutline(props) {
  return (
    <svg
      viewBox="0 0 512 512"
      fill="currentColor"
      {...props}
    >
      <path
        fill="none"
        stroke="currentColor"
        strokeMiterlimit={10}
        strokeWidth={40}
        d="M248 64C146.39 64 64 146.39 64 248s82.39 184 184 184 184-82.39 184-184S349.61 64 248 64z"
      />
      <path
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={40}
        d="M220 220h32v116"
      />
      <path
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={40}
        d="M208 340h88"
      />
      <path d="M248 130a26 26 0 1026 26 26 26 0 00-26-26z" />
    </svg>
  );
}

export default IconInformationCircleOutline;
